export default __webpack_public_path__ + "static/media/Firma_y_Sello.379ab6ae.png";